import ModalContent, { type ManageLocationsModalProps } from './ModalContent';

const ManageLocationsModal = ({ closeModal, isOpen, options }: ManageLocationsModalProps) => {
  if (!isOpen) return null;
  return <ModalContent isOpen={isOpen} closeModal={closeModal} options={options} />;
};

export default ManageLocationsModal;
